import React from "react";
import "./Partners_Home.css";
import "./NewsEvents.css"; // reuse page-header styles
import lvpeiLogo from "./assets/images/lvpei_logo.png";
import basavatarakamLogo from "./assets/images/basavatarakam_logo.png";
import tihanLogo from "./assets/images/tihan_logo.png";
import cfheLogo from "./assets/images/cfhe_logo.png";

const Partners_Home = () => {
  const logos = [
    // { src: igcarLogo, alt: "IGCAR" },
    { src: lvpeiLogo, alt: "L V Prasad Eye Institute" },
    { src: basavatarakamLogo, alt: "Basavatarakam Indo-American Cancer Hospital & Research Institute" },
    { src: tihanLogo, alt: "TiHAN IIT Hyderabad" },
    { src: cfheLogo, alt: "Center for Healthcare Entrepreneurship" },
  ];

  // Duplicate for continuous scroll
  const scrollLogos = [...logos, ...logos];

  return (
    <div className="partners-container">
      <h1 className="page-header">Partners</h1>

      <div className="partners-carousel-wrap">
        <div className="partners-carousel">
          {scrollLogos.map((logo, idx) => (
            <div className="partner-item" key={idx}>
              <img src={logo.src} alt={logo.alt} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Partners_Home;
